import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=e420b2be&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e420b2be')) {
      api.createRecord('e420b2be', component.options)
    } else {
      api.reload('e420b2be', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=e420b2be&", function () {
      api.rerender('e420b2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BNSXqP314bTI/JS/comp/ErrorMessage.vue"
export default component.exports